import { createSlice } from "@reduxjs/toolkit";
import { fetchTeacherData } from "./teacherDataThunk";

const initialState = {
  data: [{}],
  loading: false,
  error: null,
  success: null,
};

export const teacherDataSlice = createSlice({
  name: "content",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchTeacherData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchTeacherData.fulfilled, (state, action) => {
      state.loading = false;
      state.error = false;
      state.success = true;
      state.data = action.payload;
    });
    builder.addCase(fetchTeacherData.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
      state.success = false;
    });
  },
});

export default teacherDataSlice.reducer;
